import Row from 'antd/lib/row';
import EnvironmentOutlined from '@ant-design/icons/lib/icons/EnvironmentOutlined';
import { SECONDARY_COLOR } from 'src/theme';
import { BillSectionHeader } from './BillSectionHeader';
import { BillFormField, IBillSectionProps } from './BillFormField';

export const BillAddressSection = (props: IBillSectionProps) => (
    <div className="customer-bill-section-source" style={{ marginBottom: 14 }}>
        <BillSectionHeader
            icon={<EnvironmentOutlined style={{ color: SECONDARY_COLOR }} />}
            title="Address"
            fields={['address', 'city', 'state', 'zipCode']}
            editableFields={props.editableFields}
        />
        <Row gutter={[20, 10]}>
            <BillFormField {...props} label="SERVICE ADDRESS" field="address" />
            <BillFormField {...props} label="CITY" field="city" />
            <BillFormField {...props} label="STATE" field="state" />
            <BillFormField {...props} label="ZIP CODE" field="zipCode" />
        </Row>
    </div>
);
